import { render, staticRenderFns } from "./aboutLayout.vue?vue&type=template&id=697d80fe&scoped=true"
import script from "./aboutLayout.vue?vue&type=script&lang=js"
export * from "./aboutLayout.vue?vue&type=script&lang=js"
import style0 from "./aboutLayout.vue?vue&type=style&index=0&id=697d80fe&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "697d80fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('697d80fe')) {
      api.createRecord('697d80fe', component.options)
    } else {
      api.reload('697d80fe', component.options)
    }
    module.hot.accept("./aboutLayout.vue?vue&type=template&id=697d80fe&scoped=true", function () {
      api.rerender('697d80fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/allLayout/aboutLayout.vue"
export default component.exports